module.exports = __webpack_public_path__ + "static/covid_cube-45f58f4c61991ccdeeac1b382de7e6f8.png";